import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ThemeButton } from '@shared/ui/buttons';
import notFoundIcon from '@shared/assets/not-found.svg';
import tapeLeftImg from '@shared/assets/tape-left.svg';
import tapeRightImg from '@shared/assets/tape-right.svg';
import Logo from '@shared/assets/Logo';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const isLoggedIn = true;

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <section className="notFound">
      <div className="notFound__container">
        <div>
          <Logo />
        </div>
        <div>
          <img className="notFound__icon" src={notFoundIcon} alt="not found" />
          <p className="notFound__title">Page not found</p>
          <p className="notFound__subtitle">
            Something went wrong. You may have entered an incorrect link, or
            something is broken. <br />
            Try again or contact support.
          </p>
          <div className="notFound__btns">
            <ThemeButton
              appearance="secondary"
              startIcon="chat"
              onClick={() => navigate('/support')}
            >
              Support
            </ThemeButton>
            <ThemeButton
              appearance="secondary"
              endIcon="arrow-right"
              onClick={() => navigate('/')}
            >
              Return to home
            </ThemeButton>
          </div>
          <div className="notFound__block">
            <p>404</p>
          </div>
        </div>
      </div>
      <img className="notFound__tape" src={tapeLeftImg} alt="tape" />
      <img
        className="notFound__tape right-side"
        src={tapeRightImg}
        alt="tape"
      />
    </section>
  );
}
